import { render } from "./ModalAreaScan.vue?vue&type=template&id=5d4ff2c5&scoped=true&ts=true"
import script from "./ModalAreaScan.vue?vue&type=script&lang=ts"
export * from "./ModalAreaScan.vue?vue&type=script&lang=ts"

import "./ModalAreaScan.vue?vue&type=style&index=0&id=5d4ff2c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4ff2c5"]])

export default __exports__